export enum MenuTab {
  M,
  B,
  H_I,
  R_I,
  F_I,
  L,
  F,
}

export interface MenuState {
  tab: MenuTab;
  without?: boolean;
}

export enum InfoType {
  H = "how-to-play",
  F = "provably-fair",
  R = "rules",
}

export enum OperationType {
  P,
  M,
  U,
}

export interface Operation {
  type: OperationType;
  value: string;
}
